/* WOOF 26 template: header, menus, search, rails, cards, wishlist, bag drawer, film, looks,
   collection filters and the product page. Plain JS, no dependencies. */
(() => {
  const W = (window.W26 = window.W26 || {});
  const doc = document;
  const root = doc.documentElement;
  const $ = (s, el = doc) => el.querySelector(s);
  const $$ = (s, el = doc) => Array.from(el.querySelectorAll(s));
  const isRTL = () => getComputedStyle(doc.body).direction === 'rtl';
  const on = (el, ev, fn, o) => el && el.addEventListener(ev, fn, o);

  /* ---------------------------------------------------------------- utils */
  W.formatMoney = (cents, format) => {
    const f = format || W.money || '{{amount}}';
    const n = Number(cents) / 100;
    const fix = (v, d, ts = ',', ds = '.') => {
      const p = v.toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return p.join(ds);
    };
    const tmp = doc.createElement('div');
    tmp.innerHTML = f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return fix(n, 0);
      if (k === 'amount_with_comma_separator') return fix(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fix(n, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return fix(n, 2, "'", '.');
      return fix(n, 2);
    });
    // like money_without_trailing_zeros: 149.00 -> 149
    return tmp.textContent.replace(/([.,])00(?!\d)/, '');
  };

  let lockN = 0;
  W.lock = (v) => {
    lockN = Math.max(0, lockN + (v ? 1 : -1));
    root.classList.toggle('w26-lock', lockN > 0);
  };

  W.toast = (msg) => {
    let t = $('.w26-toast');
    if (!t) {
      t = doc.createElement('div');
      t.className = 'w26-toast';
      t.setAttribute('role', 'status');
      doc.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._t);
    t._t = setTimeout(() => t.classList.remove('is-on'), 2600);
  };

  const trapFocus = (box, e) => {
    if (e.key !== 'Tab') return;
    const f = $$('a[href], button:not([disabled]), input:not([type=hidden]), select, [tabindex]:not([tabindex="-1"])', box).filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    const first = f[0];
    const last = f[f.length - 1];
    if (e.shiftKey && doc.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && doc.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  /* ---------------------------------------------------------------- announcement */
  $$('[data-w26-ann]').forEach((bar) => {
    const msgs = $$('.w26-ann__msg', bar);
    if (msgs.length < 2) return;
    let i = 0;
    const speed = (Number(bar.dataset.speed) || 5) * 1000;
    setInterval(() => {
      if (doc.hidden) return;
      msgs[i].classList.remove('is-on');
      msgs[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
      msgs[i].removeAttribute('aria-hidden');
    }, speed);
  });

  /* ---------------------------------------------------------------- header */
  const hdr = $('[data-w26-hdr]');
  const setOffsets = () => {
    if (!hdr) return;
    const r = hdr.getBoundingClientRect();
    root.style.setProperty('--w26-sticky-top', Math.max(0, Math.round(r.bottom)) + 'px');
    root.style.setProperty('--w26-shade-top', Math.round(r.bottom) + 'px');
  };
  setOffsets();
  on(window, 'scroll', () => requestAnimationFrame(setOffsets), { passive: true });
  on(window, 'resize', setOffsets);

  if (hdr) {
    const wrap = $('[data-w26-mega-wrap]', hdr);
    const shade = $('[data-w26-shade]', hdr);
    let openItem = null;
    let tOpen = null;
    let tClose = null;
    const close = () => {
      if (!openItem) return;
      openItem.classList.remove('is-open');
      const a = $('.w26-nav__a', openItem);
      if (a) a.setAttribute('aria-expanded', 'false');
      openItem = null;
      $$('[data-w26-mega-sec]', wrap).forEach((s) => (s.hidden = true));
      wrap.hidden = true;
      shade.classList.remove('is-on');
      setTimeout(() => {
        if (!openItem) shade.hidden = true;
      }, 300);
    };
    const open = (li) => {
      if (openItem === li) return;
      const sec = doc.getElementById(li.dataset.w26Mega);
      if (!sec) return;
      if (openItem) {
        openItem.classList.remove('is-open');
        $('.w26-nav__a', openItem).setAttribute('aria-expanded', 'false');
      }
      $$('[data-w26-mega-sec]', wrap).forEach((s) => (s.hidden = s !== sec));
      wrap.hidden = false;
      shade.hidden = false;
      setOffsets();
      requestAnimationFrame(() => shade.classList.add('is-on'));
      li.classList.add('is-open');
      $('.w26-nav__a', li).setAttribute('aria-expanded', 'true');
      openItem = li;
    };
    $$('.w26-nav__item', hdr).forEach((li) => {
      on(li, 'mouseenter', () => {
        clearTimeout(tClose);
        clearTimeout(tOpen);
        if (li.dataset.w26Mega) tOpen = setTimeout(() => open(li), openItem ? 0 : 120);
        else tOpen = setTimeout(close, 120);
      });
      on(li, 'focusin', () => (li.dataset.w26Mega ? open(li) : close()));
    });
    on(hdr, 'mouseleave', () => {
      clearTimeout(tOpen);
      tClose = setTimeout(close, 180);
    });
    on(hdr, 'mouseenter', () => clearTimeout(tClose));
    on(shade, 'click', close);
    on(doc, 'keydown', (e) => {
      if (e.key === 'Escape' && openItem) {
        const a = $('.w26-nav__a', openItem);
        close();
        if (a) a.focus();
      }
    });
    on(hdr, 'focusout', (e) => {
      if (!hdr.contains(e.relatedTarget)) close();
    });
  }

  /* ---------------------------------------------------------------- phone menu */
  const mnav = $('[data-w26-mnav]');
  if (mnav) {
    const openers = $$('[data-w26-mnav-open]');
    let last = null;
    const show = (id) => {
      $$('[data-w26-mpanel]', mnav).forEach((p) => p.classList.toggle('is-on', p.dataset.w26Mpanel === id));
      const p = $(`[data-w26-mpanel="${id}"]`, mnav);
      if (p) {
        p.scrollTop = 0;
        const f = $('button, a', p);
        if (f) f.focus({ preventScroll: true });
      }
    };
    const openM = () => {
      last = doc.activeElement;
      mnav.hidden = false;
      show('root');
      requestAnimationFrame(() => mnav.classList.add('is-open'));
      openers.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      W.lock(true);
    };
    const closeM = () => {
      mnav.classList.remove('is-open');
      openers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      W.lock(false);
      setTimeout(() => (mnav.hidden = true), 450);
      if (last) last.focus({ preventScroll: true });
    };
    W.closeMenu = () => mnav.classList.contains('is-open') && closeM();
    openers.forEach((b) => on(b, 'click', openM));
    $$('[data-w26-mnav-close]', mnav).forEach((b) => on(b, 'click', closeM));
    $$('[data-w26-mpanel-open]', mnav).forEach((b) => on(b, 'click', () => show(b.dataset.w26MpanelOpen)));
    on(mnav, 'keydown', (e) => {
      if (e.key === 'Escape') closeM();
      trapFocus($('.w26-mnav__panel.is-on', mnav) || mnav, e);
    });
  }

  /* ---------------------------------------------------------------- search */
  const ss = $('[data-w26-search]');
  if (ss) {
    const input = $('[data-w26-search-input]', ss);
    const start = $('[data-w26-search-start]', ss);
    const results = $('[data-w26-search-results]', ss);
    let last = null;
    let ctl = null;
    let tmr = null;
    const openS = () => {
      if (W.closeMenu) W.closeMenu();
      last = doc.activeElement;
      ss.hidden = false;
      requestAnimationFrame(() => ss.classList.add('is-open'));
      W.lock(true);
      setTimeout(() => input.focus(), 60);
    };
    const closeS = () => {
      ss.classList.remove('is-open');
      W.lock(false);
      setTimeout(() => (ss.hidden = true), 300);
      if (last) last.focus({ preventScroll: true });
    };
    const run = (q) => {
      if (ctl) ctl.abort();
      if (!q.trim()) {
        results.hidden = true;
        results.innerHTML = '';
        start.hidden = false;
        return;
      }
      ctl = new AbortController();
      const url = `${W.root || '/'}search/suggest?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&section_id=w26-search-results`;
      fetch(url, { signal: ctl.signal })
        .then((r) => r.text())
        .then((html) => {
          const d = new DOMParser().parseFromString(html, 'text/html');
          const sec = d.querySelector('.shopify-section') || d.body;
          results.innerHTML = sec.innerHTML;
          results.hidden = false;
          start.hidden = true;
          initCards(results);
          W.wish.paint(results);
        })
        .catch(() => {});
    };
    $$('[data-w26-search-open]').forEach((b) => on(b, 'click', openS));
    $$('[data-w26-search-close]', ss).forEach((b) => on(b, 'click', closeS));
    on(input, 'input', () => {
      clearTimeout(tmr);
      tmr = setTimeout(() => run(input.value), 220);
    });
    $$('[data-w26-search-term]', ss).forEach((b) =>
      on(b, 'click', () => {
        input.value = b.dataset.w26SearchTerm;
        run(input.value);
        input.focus();
      })
    );
    on(ss, 'keydown', (e) => {
      if (e.key === 'Escape') closeS();
      trapFocus(ss, e);
    });
  }

  /* ---------------------------------------------------------------- rails */
  const initRail = (rail) => {
    if (rail.dataset.w26Ready) return;
    rail.dataset.w26Ready = '1';
    const track = $('[data-w26-track]', rail);
    if (!track) return;
    const prev = $('[data-w26-prev]', rail);
    const next = $('[data-w26-next]', rail);
    const prog = $('[data-w26-prog]', rail);
    const step = () => {
      const kid = track.firstElementChild;
      if (!kid) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const w = kid.getBoundingClientRect().width + gap;
      return Math.max(w, Math.floor(track.clientWidth / w) * w);
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const pos = Math.abs(track.scrollLeft);
      if (prev) prev.disabled = pos <= 2;
      if (next) next.disabled = pos >= max - 2;
      if (prog) {
        const bar = prog.parentElement;
        const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        prog.style.width = Math.min(100, ratio * 100) + '%';
        const room = bar.clientWidth - prog.clientWidth;
        const x = max > 0 ? (pos / max) * room : 0;
        prog.style.transform = `translateX(${isRTL() ? -x : x}px)`;
        bar.style.visibility = max > 2 ? 'visible' : 'hidden';
      }
    };
    const go = (dir) => track.scrollBy({ left: dir * step() * (isRTL() ? -1 : 1), behavior: 'smooth' });
    on(prev, 'click', () => go(-1));
    on(next, 'click', () => go(1));
    on(track, 'scroll', () => requestAnimationFrame(update), { passive: true });
    on(window, 'resize', update);
    update();
    setTimeout(update, 400);
  };
  const initRails = (scope = doc) => $$('[data-w26-rail]', scope).forEach(initRail);

  /* ---------------------------------------------------------------- reveal */
  const io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (es) =>
            es.forEach((e) => {
              if (e.isIntersecting) {
                e.target.classList.add('is-in');
                io.unobserve(e.target);
              }
            }),
          { rootMargin: '0px 0px -8% 0px' }
        )
      : null;
  const initReveal = (scope = doc) =>
    $$('.w26-rv:not(.is-in)', scope).forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));

  /* ---------------------------------------------------------------- wishlist */
  W.wish = {
    key: 'w26-wish',
    get() {
      try {
        return JSON.parse(localStorage.getItem(this.key) || '[]');
      } catch (e) {
        return [];
      }
    },
    set(list) {
      try {
        localStorage.setItem(this.key, JSON.stringify(list.slice(0, 60)));
      } catch (e) {}
      this.paint();
    },
    toggle(h) {
      const l = this.get();
      const i = l.indexOf(h);
      if (i >= 0) l.splice(i, 1);
      else l.unshift(h);
      this.set(l);
      return i < 0;
    },
    paint(scope = doc) {
      const l = this.get();
      $$('[data-w26-wish]', scope).forEach((b) => {
        const onn = l.includes(b.dataset.w26Wish);
        b.classList.toggle('is-on', onn);
        b.setAttribute('aria-pressed', onn ? 'true' : 'false');
      });
      $$('[data-w26-wish-count]').forEach((n) => {
        n.textContent = l.length;
        n.hidden = l.length === 0;
      });
    },
  };
  on(doc, 'click', (e) => {
    const b = e.target.closest('[data-w26-wish]');
    if (!b) return;
    e.preventDefault();
    const added = W.wish.toggle(b.dataset.w26Wish);
    W.toast(added ? 'נשמר במועדפים' : 'הוסר מהמועדפים');
  });

  const fetchCard = (handle) =>
    fetch(`${W.root || '/'}products/${encodeURIComponent(handle)}?section_id=w26-card-one`)
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        if (!html) return '';
        const d = new DOMParser().parseFromString(html, 'text/html');
        const c = d.querySelector('.w26-card');
        return c ? c.outerHTML : '';
      })
      .catch(() => '');

  const wl = $('[data-w26-wishlist]');
  if (wl) {
    const grid = $('[data-w26-wl-grid]', wl);
    const list = W.wish.get();
    $('[data-w26-wl-empty]', wl).hidden = list.length > 0;
    $('[data-w26-wl-cta]', wl).hidden = false;
    Promise.all(list.map(fetchCard)).then((cards) => {
      grid.innerHTML = cards.filter(Boolean).map((c) => `<li class="w26-c__item">${c}</li>`).join('');
      initCards(grid);
      W.wish.paint(grid);
    });
  }

  /* ---------------------------------------------------------------- bag */
  const cd = $('[data-w26-cart]');
  const sectionsUrl = () => location.pathname;
  const cartPage = $('[data-w26-cartpage]');
  const boxes = () => [cd, cartPage].filter(Boolean);
  const swapCart = (html) => {
    if (!html) return;
    const d = new DOMParser().parseFromString(html, 'text/html');
    const inner = d.querySelector('[data-w26-cart-inner]');
    if (!inner) return;
    boxes().forEach((box) => {
      const cur = $('[data-w26-cart-inner]', box);
      if (!cur) return;
      // keep keyboard focus where it was when the contents are replaced
      const a = doc.activeElement;
      const had = a && box.contains(a);
      const row = had && a.closest('[data-w26-line]');
      const key = row ? [row.dataset.w26Line, $$('[data-w26-qty]', row).indexOf(a)] : null;
      cur.replaceWith(inner.cloneNode(true));
      if (had) {
        initCart();
        const nrow = key && $(`[data-w26-line="${key[0]}"]`, box);
        const again = nrow && $$('[data-w26-qty]', nrow)[key[1]];
        const panel = box === cd ? $('.w26-cd__panel', cd) : null;
        if (again || panel) (again || panel).focus({ preventScroll: true });
      }
    });
    initCart();
  };

  const setCount = (n) =>
    $$('[data-w26-cart-count]').forEach((el) => {
      el.textContent = n;
      el.hidden = !n;
    });
  let lastFocus = null;
  W.openCart = () => {
    if (!cd) return (location.href = W.cartUrl || '/cart');
    lastFocus = doc.activeElement;
    cd.hidden = false;
    requestAnimationFrame(() => cd.classList.add('is-open'));
    W.lock(true);
    const p = $('.w26-cd__panel', cd);
    setTimeout(() => p && p.focus({ preventScroll: true }), 80);
    initRails(cd);
  };
  W.closeCart = () => {
    if (!cd || cd.hidden) return;
    cd.classList.remove('is-open');
    W.lock(false);
    setTimeout(() => (cd.hidden = true), 450);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };
  W.addToCart = (items) =>
    fetch(`${W.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: 'w26-cart-drawer', sections_url: sectionsUrl() }),
    })
      .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (!ok) throw new Error(j.description || j.message || 'error');
        if (j.sections) swapCart(j.sections['w26-cart-drawer']);
        return fetch(`${W.root || '/'}cart.js`).then((r) => r.json());
      })
      .then((cart) => {
        setCount(cart.item_count);
        W.openCart();
        return cart;
      });
  const changeLine = (line, quantity) => {
    boxes().forEach((x) => x.classList.add('is-busy'));
    return fetch(`${W.root || '/'}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: 'w26-cart-drawer', sections_url: sectionsUrl() }),
    })
      .then((r) => r.json())
      .then((j) => {
        if (j.sections) swapCart(j.sections['w26-cart-drawer']);
        setCount(j.item_count);
      })
      .catch(() => W.toast('משהו השתבש, נסו שוב'))
      .finally(() => boxes().forEach((x) => x.classList.remove('is-busy')));
  };
  const initCart = () => {
    boxes().forEach((box) => {
      $$('[data-w26-cart-close]', box).forEach((b) => (b.onclick = W.closeCart));
      $$('[data-w26-qty]', box).forEach((b) => {
        b.onclick = () => {
          const row = b.closest('[data-w26-line]');
          changeLine(Number(row.dataset.w26Line), Number(b.dataset.w26Qty));
        };
      });
      initCards(box);
      $$('[data-w26-rail]', box).forEach((r) => delete r.dataset.w26Ready);
      initRails(box);
      W.wish.paint(box);
    });
  };
  if (cartPage && !cd) initCart();
  if (cd) {
    initCart();
    on(cd, 'keydown', (e) => trapFocus($('.w26-cd__panel', cd), e));
    on(doc, 'keydown', (e) => {
      if (e.key === 'Escape' && !cd.hidden) W.closeCart();
    });
    $$('[data-w26-cart-open]').forEach((a) =>
      on(a, 'click', (e) => {
        if (location.pathname === (W.cartUrl || '/cart')) return;
        e.preventDefault();
        W.openCart();
      })
    );
  }

  /* ---------------------------------------------------------------- cards */
  function initCards(scope = doc) {
    $$('[data-w26-card]', scope).forEach((card) => {
      if (card.dataset.w26Ready) return;
      card.dataset.w26Ready = '1';
      const imgs = (() => {
        const j = $('[data-w26-imgs]', card);
        try {
          return j ? JSON.parse(j.textContent) : [];
        } catch (e) {
          return [];
        }
      })();
      let idx = 0;
      $$('[data-w26-pg]', card).forEach((b) =>
        on(b, 'click', (e) => {
          e.preventDefault();
          if (!imgs.length) return;
          idx = (idx + Number(b.dataset.w26Pg) + imgs.length) % imgs.length;
          const img = $('.w26-card__img:not(.w26-card__img--2)', card);
          if (img) {
            img.removeAttribute('srcset');
            img.src = imgs[idx];
          }
          card.classList.add('is-paged');
        })
      );
      const qo = $('[data-w26-qa-open]', card);
      const qp = $('[data-w26-qa-panel]', card);
      if (qo && qp) {
        on(qo, 'click', (e) => {
          e.preventDefault();
          qp.hidden = false;
          qo.setAttribute('aria-expanded', 'true');
          const f = $('button:not([disabled])', qp);
          if (f) f.focus({ preventScroll: true });
        });
        on(card, 'mouseleave', () => {
          qp.hidden = true;
          qo.setAttribute('aria-expanded', 'false');
        });
      }
      $$('[data-w26-add]', card).forEach((b) =>
        on(b, 'click', (e) => {
          e.preventDefault();
          b.disabled = true;
          W.addToCart([{ id: Number(b.dataset.w26Add), quantity: 1 }])
            .catch((err) => W.toast(err.message || 'לא הצלחנו להוסיף לסל'))
            .finally(() => {
              b.disabled = false;
              if (qp) qp.hidden = true;
            });
        })
      );
    });
  }

  /* ---------------------------------------------------------------- film */
  $$('[data-w26-film]').forEach((sec) => {
    const vids = $$('video', sec);
    const vis = () => vids.find((v) => v.offsetParent !== null) || vids[0];
    const play = $('[data-w26-film-play]', sec);
    const snd = $('[data-w26-film-sound]', sec);
    const bar = $('[data-w26-film-bar]', sec);
    vids.forEach((v) => {
      v.muted = true;
      v.playsInline = true;
      on(v, 'timeupdate', () => {
        if (v === vis() && v.duration) bar.style.width = (v.currentTime / v.duration) * 100 + '%';
      });
    });
    on(play, 'click', () => {
      const v = vis();
      if (!v) return;
      if (v.paused) {
        v.play();
        play.setAttribute('aria-pressed', 'true');
      } else {
        v.pause();
        play.setAttribute('aria-pressed', 'false');
      }
    });
    on(snd, 'click', () => {
      const v = vis();
      if (!v) return;
      v.muted = !v.muted;
      snd.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((es) =>
        es.forEach((e) => {
          const v = vis();
          if (!v) return;
          if (e.isIntersecting && play.getAttribute('aria-pressed') === 'true') v.play().catch(() => {});
          else v.pause();
        })
      ).observe(sec);
    }
  });

  /* ---------------------------------------------------------------- shop the look */
  $$('[data-w26-look]').forEach((look) => {
    const more = $('[data-w26-look-more]', look);
    const panel = $('[data-w26-look-panel]', look);
    const total = $('[data-w26-look-total]', look);
    const add = $('[data-w26-look-add]', look);
    const msg = $('[data-w26-look-msg]', look);
    const picks = $$('[data-w26-look-pick]', look);
    const recalc = () => {
      const sum = picks.filter((p) => p.checked).reduce((a, p) => a + Number(p.dataset.price || 0), 0);
      if (total) total.textContent = W.formatMoney(sum);
      if (add) add.disabled = sum === 0;
    };
    on(more, 'click', () => {
      const openNow = panel.hidden;
      panel.hidden = !openNow;
      more.setAttribute('aria-expanded', openNow ? 'true' : 'false');
    });
    picks.forEach((p) => on(p, 'change', recalc));
    on(add, 'click', () => {
      msg.textContent = '';
      const items = [];
      let missing = false;
      $$('.w26-look__item', look).forEach((li) => {
        const pick = $('[data-w26-look-pick]', li);
        if (!pick || !pick.checked || pick.disabled) return;
        const sel = $('[data-w26-look-var]', li);
        const id = pick.dataset.variant || (sel && sel.value);
        if (!id) {
          missing = true;
          if (sel) sel.classList.add('is-missing');
          return;
        }
        if (sel) sel.classList.remove('is-missing');
        items.push({ id: Number(id), quantity: 1 });
      });
      if (missing) {
        panel.hidden = false;
        more.setAttribute('aria-expanded', 'true');
        msg.textContent = look.closest('[data-w26-rail]').dataset.missing || W.sizeMissing || 'צריך לבחור מידה';
        const s = $('.is-missing', look);
        if (s) s.focus();
        return;
      }
      if (!items.length) return;
      add.disabled = true;
      W.addToCart(items)
        .catch((err) => (msg.textContent = err.message || 'לא הצלחנו להוסיף לסל'))
        .finally(() => (add.disabled = false));
    });
    $$('[data-w26-look-var]', look).forEach((s) => on(s, 'change', () => s.classList.remove('is-missing')));
  });

  /* ---------------------------------------------------------------- footer accordion */
  $$('[data-w26-acc]').forEach((acc) => {
    const t = $('.w26-ftr__acc-t', acc);
    on(t, 'click', () => {
      if (window.innerWidth > 989) return;
      t.setAttribute('aria-expanded', t.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    });
  });

  /* ---------------------------------------------------------------- collection */
  const coll = $('[data-w26-coll]');
  if (coll) {
    const sectionId = coll.dataset.section;
    const grid = () => $('[data-w26-grid]', coll);
    const setCols = () => {
      let d = '4';
      let m = '2';
      try {
        d = localStorage.getItem('w26-cols') || '4';
        m = localStorage.getItem('w26-cols-m') || '2';
      } catch (e) {}
      coll.style.setProperty('--w26-cols', d);
      coll.style.setProperty('--w26-cols-m', m);
      $$('[data-w26-view]', coll).forEach((b) => b.classList.toggle('is-on', b.dataset.w26View === d));
      $$('[data-w26-view-m]', coll).forEach((b) => b.classList.toggle('is-on', b.dataset.w26ViewM === m));
    };
    const bindView = () => {
      $$('[data-w26-view]', coll).forEach((b) =>
        on(b, 'click', () => {
          try {
            localStorage.setItem('w26-cols', b.dataset.w26View);
          } catch (e) {}
          setCols();
        })
      );
      $$('[data-w26-view-m]', coll).forEach((b) =>
        on(b, 'click', () => {
          try {
            localStorage.setItem('w26-cols-m', b.dataset.w26ViewM);
          } catch (e) {}
          setCols();
        })
      );
    };

    let openFg = null;
    const closeFg = () => {
      if (!openFg) return;
      openFg.classList.remove('is-open');
      $('[data-w26-fg-btn]', openFg).setAttribute('aria-expanded', 'false');
      openFg = null;
    };
    const drawer = () => $('[data-w26-fdrawer]', coll);
    const mobile = () => window.innerWidth <= 989;

    const load = (url, replace = true) => {
      coll.classList.add('w26-coll-busy');
      const u = new URL(url, location.href);
      u.searchParams.set('section_id', sectionId);
      return fetch(u.toString())
        .then((r) => r.text())
        .then((html) => {
          const d = new DOMParser().parseFromString(html, 'text/html');
          if (replace) {
            const nb = d.querySelector('[data-w26-filters]');
            const nr = d.querySelector('[data-w26-results]');
            const keepOpen = drawer() && drawer().classList.contains('is-open');
            const openKey = openFg ? $$('[data-w26-fg]', coll).indexOf(openFg) : -1;
            if (nb) $('[data-w26-filters]', coll).replaceWith(nb);
            if (nr) $('[data-w26-results]', coll).replaceWith(nr);
            bindFilters();
            if (keepOpen && drawer()) drawer().classList.add('is-open');
            if (openKey >= 0 && mobile()) {
              const fg = $$('[data-w26-fg]', coll)[openKey];
              if (fg) {
                fg.classList.add('is-open');
                openFg = fg;
              }
            }
            const clean = new URL(url, location.href);
            clean.searchParams.delete('section_id');
            history.replaceState({}, '', clean.pathname + clean.search);
          }
          return d;
        })
        .finally(() => coll.classList.remove('w26-coll-busy'));
    };

    const apply = () => {
      const form = $('[data-w26-filters]', coll);
      const fd = new FormData(form);
      const p = new URLSearchParams();
      for (const [k, v] of fd.entries()) if (v !== '') p.append(k, v);
      load(`${location.pathname}?${p.toString()}`);
    };

    let moreIO = null;
    const bindMore = () => {
      const more = $('.w26-c__more', coll);
      if (!more) return;
      const btn = $('[data-w26-more]', more);
      const loadNext = (e) => {
        if (e) e.preventDefault();
        const next = more.dataset.w26Next;
        if (!next || more.dataset.busy) return;
        more.dataset.busy = '1';
        load(next, false).then((d) => {
          const items = d.querySelectorAll('[data-w26-grid] > *');
          const g = grid();
          items.forEach((it) => g.appendChild(it));
          const nm = d.querySelector('.w26-c__more');
          if (nm) {
            more.replaceWith(nm);
            bindMore();
          }
          initCards(g);
          W.wish.paint(g);
        });
      };
      on(btn, 'click', loadNext);
      if (moreIO) moreIO.disconnect();
      if ('IntersectionObserver' in window && more.dataset.w26Next) {
        more.classList.add('is-auto');
        moreIO = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && loadNext()), { rootMargin: '600px 0px' });
        moreIO.observe(more);
      }
    };

    function bindFilters() {
      const form = $('[data-w26-filters]', coll);
      if (!form) return;
      on(form, 'submit', (e) => e.preventDefault());
      $$('[data-w26-fg]', form).forEach((fg) => {
        const btn = $('[data-w26-fg-btn]', fg);
        on(btn, 'click', (e) => {
          e.stopPropagation();
          if (openFg === fg) return closeFg();
          if (!mobile()) closeFg();
          fg.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          openFg = fg;
        });
      });
      $$('.w26-opt__in', form).forEach((i) => on(i, 'change', apply));
      $$('[data-w26-price]', form).forEach((pr) => {
        const a = $('[data-w26-range="a"]', pr);
        const b = $('[data-w26-range="b"]', pr);
        const fill = $('.w26-range__fill', pr);
        const max = Number(pr.dataset.max) || 1;
        const paint = () => {
          let va = Number(a.value);
          let vb = Number(b.value);
          if (va > vb) [va, vb] = [vb, va];
          fill.style.setProperty('--a', (va / max) * 100 + '%');
          fill.style.setProperty('--b', (vb / max) * 100 + '%');
          $('[data-w26-pa]', pr).textContent = va + '₪';
          $('[data-w26-pb]', pr).textContent = vb + '₪';
          $('[data-w26-pin="a"]', pr).value = va > 0 ? va : '';
          $('[data-w26-pin="b"]', pr).value = vb < max ? vb : '';
        };
        [a, b].forEach((r) => {
          on(r, 'input', paint);
          on(r, 'change', apply);
        });
        paint();
      });
      on($('[data-w26-fdrawer-open]', form), 'click', () => {
        drawer().classList.add('is-open');
        root.classList.add('w26-fd-on');
        W.lock(true);
      });
      $$('[data-w26-fdrawer-close]', form).forEach((b) =>
        on(b, 'click', () => {
          drawer().classList.remove('is-open');
          root.classList.remove('w26-fd-on');
          W.lock(false);
        })
      );
      bindView();
      setCols();
      bindMore();
      initCards(coll);
      W.wish.paint(coll);
    }
    on(doc, 'click', (e) => {
      if (openFg && !mobile() && !openFg.contains(e.target)) closeFg();
    });
    on(doc, 'keydown', (e) => e.key === 'Escape' && closeFg());
    bindFilters();
  }

  /* ---------------------------------------------------------------- product page */
  const pdp = $('[data-w26-pdp]');
  if (pdp) {
    const data = JSON.parse($('[data-w26-product]', pdp).textContent);
    const form = $('[data-w26-pdp-form]', pdp);
    const vid = $('[data-w26-vid]', pdp);
    const atc = $('[data-w26-atc]', pdp);
    const atcT = $('[data-w26-atc-t]', pdp);
    const err = $('[data-w26-pdp-err]', pdp);
    const priceBox = $('[data-w26-price]', pdp);
    const pbar = $('[data-w26-pbar]', pdp);
    const pbarBtn = $('[data-w26-pbar-btn]', pdp);
    const addLabel = atcT ? atcT.textContent : '';
    const soldLabel = 'אזל מהמלאי';
    let current = data.variants.find((v) => String(v.id) === vid.value) || data.variants[0];
    const selected = current ? current.options.slice() : [];

    const paintOptions = () => {
      $$('[data-w26-opt]', pdp).forEach((box) => {
        const oi = Number(box.dataset.w26Opt);
        const val = $('[data-w26-opt-val]', box);
        if (val) val.textContent = selected[oi];
        $$('[data-w26-val]', box).forEach((b) => {
          const v = b.dataset.w26Val;
          const sel = v === selected[oi];
          b.classList.toggle('is-sel', sel);
          b.setAttribute('aria-pressed', sel ? 'true' : 'false');
          const test = selected.slice();
          test[oi] = v;
          const match = data.variants.find((x) => x.options.every((o, i) => o === test[i]));
          b.classList.toggle('is-na', !match || !match.available);
        });
      });
    };
    const paintVariant = () => {
      const v = data.variants.find((x) => x.options.every((o, i) => o === selected[i]));
      current = v || null;
      if (!v) {
        atc.disabled = true;
        atcT.textContent = 'לא זמין';
        if (pbarBtn) pbarBtn.disabled = true;
        return;
      }
      vid.value = v.id;
      atc.disabled = !v.available;
      atcT.textContent = v.available ? addLabel : soldLabel;
      if (pbarBtn) {
        pbarBtn.disabled = !v.available;
        pbarBtn.textContent = v.available ? addLabel : soldLabel;
      }
      const now = W.formatMoney(v.price);
      priceBox.innerHTML =
        (v.compare_at_price > v.price ? `<s class="w26-pdp__was">${W.formatMoney(v.compare_at_price)}</s>` : '') +
        `<span class="w26-pdp__now w26-money">${now}</span>`;
      const pp = $('[data-w26-pbar-price]', pdp);
      if (pp) pp.textContent = now;
      const pv = $('[data-w26-pbar-var]', pdp);
      if (pv) pv.textContent = v.title;
      const u = new URL(location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.toString());
      if (v.featured_media) {
        const slide = $(`[data-media-id="${v.featured_media.id}"]`, pdp);
        const track = $('[data-w26-pdp-track]', pdp);
        if (slide && track) {
          if (window.innerWidth <= 989) {
            const tr = track.getBoundingClientRect();
            const sr = slide.getBoundingClientRect();
            track.scrollBy({ left: sr.left - tr.left, behavior: 'smooth' });
          } else if (slide !== track.firstElementChild) {
            track.insertBefore(slide, track.firstElementChild);
          }
        }
      }
    };
    $$('[data-w26-opt]', pdp).forEach((box) => {
      const oi = Number(box.dataset.w26Opt);
      $$('[data-w26-val]', box).forEach((b) =>
        on(b, 'click', () => {
          selected[oi] = b.dataset.w26Val;
          if (!data.variants.find((x) => x.options.every((o, i) => o === selected[i]) && x.available)) {
            const alt = data.variants.find((x) => x.available && x.options[oi] === selected[oi]);
            if (alt) alt.options.forEach((o, i) => (selected[i] = o));
          }
          err.hidden = true;
          paintOptions();
          paintVariant();
        })
      );
    });
    paintOptions();

    on(form, 'submit', (e) => {
      e.preventDefault();
      if (!current || !current.available) return;
      atc.classList.add('is-busy');
      atc.disabled = true;
      W.addToCart([{ id: Number(vid.value), quantity: 1 }])
        .catch((x) => {
          err.textContent = x.message || 'לא הצלחנו להוסיף לסל';
          err.hidden = false;
        })
        .finally(() => {
          atc.classList.remove('is-busy');
          atc.disabled = !(current && current.available);
        });
    });
    on(pbarBtn, 'click', () => form.requestSubmit ? form.requestSubmit() : atc.click());

    // phone gallery counter
    const track = $('[data-w26-pdp-track]', pdp);
    const nEl = $('[data-w26-pdp-n]', pdp);
    const bar = $('[data-w26-pdp-bar]', pdp);
    const n = track ? track.children.length : 0;
    on(
      track,
      'scroll',
      () =>
        requestAnimationFrame(() => {
          if (!n || window.innerWidth > 989) return;
          const i = Math.min(n - 1, Math.round(Math.abs(track.scrollLeft) / track.clientWidth));
          if (nEl) nEl.textContent = i + 1;
          if (bar) bar.style.right = (i / n) * 100 + '%';
        }),
      { passive: true }
    );

    // sticky bag bar on phones
    if (pbar) {
      // shown once the main button has scrolled above the screen (a scroll check, so fast flings are not missed)
      let tick = 0;
      const check = () => {
        tick = 0;
        pbar.classList.toggle('is-in', atc.getBoundingClientRect().bottom < 0);
      };
      on(window, 'scroll', () => tick || (tick = requestAnimationFrame(check)), { passive: true });
      check();
      pbar.removeAttribute('aria-hidden');
      if (pbarBtn) pbarBtn.removeAttribute('tabindex');
    }

    // zoom
    const zb = $('[data-w26-zoombox]', pdp);
    $$('[data-w26-zoom]', pdp).forEach((b) =>
      on(b, 'click', () => {
        if (!zb) return;
        zb.hidden = false;
        W.lock(true);
        const img = $$('img', zb)[Number(b.dataset.w26Zoom)];
        if (img) setTimeout(() => img.scrollIntoView({ block: 'start' }), 30);
        $('[data-w26-zoom-close]', zb).focus();
      })
    );
    const closeZoom = () => {
      zb.hidden = true;
      W.lock(false);
    };
    on($('[data-w26-zoom-close]', zb), 'click', closeZoom);
    on(zb, 'keydown', (e) => e.key === 'Escape' && closeZoom());

    // recently viewed
    try {
      const k = 'w26-recent';
      const l = JSON.parse(localStorage.getItem(k) || '[]').filter((h) => h !== data.handle);
      W.recent = l.slice(0, 8);
      localStorage.setItem(k, JSON.stringify([data.handle].concat(l).slice(0, 12)));
    } catch (e) {
      W.recent = [];
    }
  }

  /* recommendations + recently viewed under the product */
  $$('[data-w26-more]').forEach((box) => {
    const put = (url, slot) =>
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const d = new DOMParser().parseFromString(html, 'text/html');
          const block = d.querySelector('.w26-more__block');
          const target = $(slot, box);
          if (block && target) {
            target.replaceWith(block);
            initCards(block);
            initRails(box);
            W.wish.paint(block);
          }
        })
        .catch(() => {});
    if (box.dataset.intentUrl) put(box.dataset.intentUrl, '[data-w26-more-look]');
    if (box.dataset.url) put(box.dataset.url, '[data-w26-more-like]');
    const rec = $('[data-w26-recent]', box);
    const list = W.recent || [];
    if (rec && list.length) {
      Promise.all(list.slice(0, 4).map(fetchCard)).then((cards) => {
        const ok = cards.filter(Boolean);
        if (!ok.length) return;
        $('[data-w26-recent-track]', rec).innerHTML = ok.join('');
        rec.hidden = false;
        initCards(rec);
        initRails(box);
        W.wish.paint(rec);
      });
    }
  });

  /* ---------------------------------------------------------------- boot */
  initRails();
  initReveal();
  initCards();
  W.wish.paint();
  doc.addEventListener('shopify:section:load', (e) => {
    initRails(e.target);
    initReveal(e.target);
    initCards(e.target);
    W.wish.paint(e.target);
  });
})();
